//#region node_modules/.pnpm/gsap@3.14.2/node_modules/gsap/utils/paths.js
/*!
* paths 3.14.2
* https://gsap.com
*
* Copyright 2008-2025, GreenSock. All rights reserved.
* Subject to the terms at https://gsap.com/standard-license
* @author: Jack Doyle, jack@greensock.com
*/
var _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi, _numbersExp = /(?:(-)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi, _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi, _selectorExp = /(^[#\.][a-z]|[a-y][a-z])/i, _DEG2RAD = Math.PI / 180;
180 / Math.PI;
var _sin = Math.sin, _cos = Math.cos, _abs = Math.abs, _sqrt = Math.sqrt, _atan2 = Math.atan2, _largeNum = 1e8, _isString = function _isString(value) {
	return typeof value === "string";
}, _isNumber = function _isNumber(value) {
	return typeof value === "number";
}, _roundingNum = 1e5, _round = function _round(value) {
	return Math.round(value * _roundingNum) / _roundingNum || 0;
}, _segmentIsClosed = function _segmentIsClosed(segment) {
	return segment.closed = Math.abs(segment[0] - segment[segment.length - 2]) < .001 && Math.abs(segment[1] - segment[segment.length - 1]) < .001;
}, _getSampleIndex = function _getSampleIndex(samples, length, progress) {
	var l = samples.length, i = ~~(progress * l);
	if (samples[i] > length) {
		while (--i && samples[i] > length);
		i < 0 && (i = 0);
	} else while (samples[++i] < length && i < l);
	return i < l ? i : l - 1;
};
function getRawPath(value) {
	value = _isString(value) && _selectorExp.test(value) ? document.querySelector(value) || value : value;
	var e = value.getAttribute ? value : 0, rawPath;
	if (e && (value = value.getAttribute("d"))) {
		if (!e._gsPath) e._gsPath = {};
		rawPath = e._gsPath[value];
		return rawPath && !rawPath._dirty ? rawPath : e._gsPath[value] = stringToRawPath(value);
	}
	return !value ? console.warn("Expecting a <path> element or an SVG path data string") : _isString(value) ? stringToRawPath(value) : _isNumber(value[0]) ? [value] : value;
}
function reverseSegment(segment) {
	var i = 0, y;
	segment.reverse();
	for (; i < segment.length; i += 2) {
		y = segment[i];
		segment[i] = segment[i + 1];
		segment[i + 1] = y;
	}
	segment.reversed = !segment.reversed;
}
var _createPath = function _createPath(e, ignore) {
	var path = document.createElementNS("http://www.w3.org/2000/svg", "path"), attr = [].slice.call(e.attributes), i = attr.length, name;
	ignore = "," + ignore + ",";
	while (--i > -1) {
		name = attr[i].nodeName.toLowerCase();
		if (ignore.indexOf("," + name + ",") < 0) path.setAttributeNS(null, name, attr[i].nodeValue);
	}
	return path;
}, _typeAttrs = {
	rect: "rx,ry,x,y,width,height",
	circle: "r,cx,cy",
	ellipse: "rx,ry,cx,cy",
	line: "x1,x2,y1,y2"
}, _attrToObj = function _attrToObj(e, attrs) {
	var props = attrs ? attrs.split(",") : [], obj = {}, i = props.length;
	while (--i > -1) obj[props[i]] = +e.getAttribute(props[i]) || 0;
	return obj;
};
function convertToPath(element, swap) {
	var type = element.tagName.toLowerCase(), circ = .552284749831, data, x, y, r, ry, path, rcirc, rycirc, points, w, h, x2, x3, x4, x5, x6, y2, y3, y4, y5, y6, attr;
	if (type === "path" || !element.getBBox) return element;
	path = _createPath(element, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
	attr = _attrToObj(element, _typeAttrs[type]);
	if (type === "rect") {
		r = attr.rx;
		ry = attr.ry || r;
		x = attr.x;
		y = attr.y;
		w = attr.width - r * 2;
		h = attr.height - ry * 2;
		if (r || ry) {
			x2 = x + r * (1 - circ);
			x3 = x + r;
			x4 = x3 + w;
			x5 = x4 + r * circ;
			x6 = x4 + r;
			y2 = y + ry * (1 - circ);
			y3 = y + ry;
			y4 = y3 + h;
			y5 = y4 + ry * circ;
			y6 = y4 + ry;
			data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [
				x6,
				y5,
				x5,
				y6,
				x4,
				y6,
				x4 - (x4 - x3) / 3,
				y6,
				x3 + (x4 - x3) / 3,
				y6,
				x3,
				y6,
				x2,
				y6,
				x,
				y5,
				x,
				y4,
				x,
				y4 - (y4 - y3) / 3,
				x,
				y3 + (y4 - y3) / 3,
				x,
				y3,
				x,
				y2,
				x2,
				y,
				x3,
				y,
				x3 + (x4 - x3) / 3,
				y,
				x4 - (x4 - x3) / 3,
				y,
				x4,
				y,
				x5,
				y,
				x6,
				y2,
				x6,
				y3
			].join(",") + "z";
		} else data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
	} else if (type === "circle" || type === "ellipse") {
		if (type === "circle") {
			r = ry = attr.r;
			rycirc = r * circ;
		} else {
			r = attr.rx;
			ry = attr.ry;
			rycirc = ry * circ;
		}
		x = attr.cx;
		y = attr.cy;
		rcirc = r * circ;
		data = "M" + (x + r) + "," + y + " C" + [
			x + r,
			y + rycirc,
			x + rcirc,
			y + ry,
			x,
			y + ry,
			x - rcirc,
			y + ry,
			x - r,
			y + rycirc,
			x - r,
			y,
			x - r,
			y - rycirc,
			x - rcirc,
			y - ry,
			x,
			y - ry,
			x + rcirc,
			y - ry,
			x + r,
			y - rycirc,
			x + r,
			y
		].join(",") + "z";
	} else if (type === "line") data = "M" + attr.x1 + "," + attr.y1 + " L" + attr.x2 + "," + attr.y2;
	else if (type === "polyline" || type === "polygon") {
		points = (element.getAttribute("points") + "").match(_numbersExp) || [];
		x = points.shift();
		y = points.shift();
		data = "M" + x + "," + y + " L" + points.join(",");
		if (type === "polygon") data += "," + x + "," + y + "z";
	}
	path.setAttribute("d", rawPathToString(path._gsRawPath = stringToRawPath(data)));
	if (swap && element.parentNode) {
		element.parentNode.insertBefore(path, element);
		element.parentNode.removeChild(element);
	}
	return path;
}
function measureSegment(segment, startIndex, bezierQty) {
	startIndex = startIndex || 0;
	if (!segment.samples) {
		segment.samples = [];
		segment.lookup = [];
	}
	var resolution = ~~segment.resolution || 12, inc = 1 / resolution, endIndex = bezierQty ? startIndex + bezierQty * 6 + 1 : segment.length, x1 = segment[startIndex], y1 = segment[startIndex + 1], samplesIndex = startIndex ? startIndex / 6 * resolution : 0, samples = segment.samples, lookup = segment.lookup, min = (startIndex ? segment.minLength : _largeNum) || _largeNum, prevLength = samples[samplesIndex + bezierQty * resolution - 1], length = startIndex ? samples[samplesIndex - 1] : 0, i, j, x4, x3, x2, xd, xd1, y4, y3, y2, yd, yd1, inv, t, lengthIndex, l, segLength;
	samples.length = lookup.length = 0;
	for (j = startIndex + 2; j < endIndex; j += 6) {
		x4 = segment[j + 4] - x1;
		x3 = segment[j + 2] - x1;
		x2 = segment[j] - x1;
		y4 = segment[j + 5] - y1;
		y3 = segment[j + 3] - y1;
		y2 = segment[j + 1] - y1;
		xd = xd1 = yd = yd1 = 0;
		if (_abs(x4) < .01 && _abs(y4) < .01 && _abs(x2) + _abs(y2) < .01) {
			if (segment.length > 8) {
				segment.splice(j, 6);
				j -= 6;
				endIndex -= 6;
			}
		} else for (i = 1; i <= resolution; i++) {
			t = inc * i;
			inv = 1 - t;
			xd = xd1 - (xd1 = (t * t * x4 + 3 * inv * (t * x3 + inv * x2)) * t);
			yd = yd1 - (yd1 = (t * t * y4 + 3 * inv * (t * y3 + inv * y2)) * t);
			l = _sqrt(yd * yd + xd * xd);
			if (l < min) min = l;
			length += l;
			samples[samplesIndex++] = length;
		}
		x1 += x4;
		y1 += y4;
	}
	if (prevLength) {
		prevLength -= length;
		for (; samplesIndex < samples.length; samplesIndex++) samples[samplesIndex] += prevLength;
	}
	if (samples.length && min) {
		segment.totalLength = segLength = samples[samples.length - 1] || 0;
		segment.minLength = min;
		if (segLength / min < 9999) {
			l = lengthIndex = 0;
			for (i = 0; i < segLength; i += min) lookup[l++] = samples[lengthIndex] < i ? ++lengthIndex : lengthIndex;
		}
	} else segment.totalLength = samples[0] = 0;
	return startIndex ? length - samples[startIndex / 2 - 1] : length;
}
function cacheRawPathMeasurements(rawPath, resolution) {
	var pathLength, points, i;
	for (i = pathLength = points = 0; i < rawPath.length; i++) {
		rawPath[i].resolution = ~~resolution || 12;
		pathLength += measureSegment(rawPath[i]);
		points += rawPath[i].length;
	}
	rawPath.totalPoints = points;
	rawPath.totalLength = pathLength;
	return rawPath;
}
function transformRawPath(rawPath, a, b, c, d, tx, ty) {
	var j = rawPath.length, segment, l, i, x, y;
	while (--j > -1) {
		segment = rawPath[j];
		l = segment.length;
		for (i = 0; i < l; i += 2) {
			x = segment[i];
			y = segment[i + 1];
			segment[i] = x * a + y * c + tx;
			segment[i + 1] = x * b + y * d + ty;
		}
	}
	rawPath._dirty = 1;
	return rawPath;
}
function arcToSegment(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
	if (lastX === x && lastY === y) return;
	rx = _abs(rx);
	ry = _abs(ry);
	var angleRad = angle % 360 * _DEG2RAD, cosAngle = _cos(angleRad), sinAngle = _sin(angleRad), PI = Math.PI, TWOPI = PI * 2, dx2 = (lastX - x) / 2, dy2 = (lastY - y) / 2, x1 = cosAngle * dx2 + sinAngle * dy2, y1 = -sinAngle * dx2 + cosAngle * dy2, x1_sq = x1 * x1, y1_sq = y1 * y1, radiiCheck = x1_sq / (rx * rx) + y1_sq / (ry * ry);
	if (radiiCheck > 1) {
		rx = _sqrt(radiiCheck) * rx;
		ry = _sqrt(radiiCheck) * ry;
	}
	var rx_sq = rx * rx, ry_sq = ry * ry, sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
	if (sq < 0) sq = 0;
	var coef = (largeArcFlag === sweepFlag ? -1 : 1) * _sqrt(sq), cx1 = coef * (rx * y1 / ry), cy1 = coef * -(ry * x1 / rx), sx2 = (lastX + x) / 2, sy2 = (lastY + y) / 2, cx = sx2 + (cosAngle * cx1 - sinAngle * cy1), cy = sy2 + (sinAngle * cx1 + cosAngle * cy1), ux = (x1 - cx1) / rx, uy = (y1 - cy1) / ry, vx = (-x1 - cx1) / rx, vy = (-y1 - cy1) / ry, temp = ux * ux + uy * uy, angleStart = (uy < 0 ? -1 : 1) * Math.acos(ux / _sqrt(temp)), angleExtent = (ux * vy - uy * vx < 0 ? -1 : 1) * Math.acos((ux * vx + uy * vy) / _sqrt(temp * (vx * vx + vy * vy)));
	isNaN(angleExtent) && (angleExtent = PI);
	if (!sweepFlag && angleExtent > 0) angleExtent -= TWOPI;
	else if (sweepFlag && angleExtent < 0) angleExtent += TWOPI;
	angleStart %= TWOPI;
	angleExtent %= TWOPI;
	var segments = Math.ceil(_abs(angleExtent) / (TWOPI / 4)), rawPath = [], angleIncrement = angleExtent / segments, controlLength = 4 / 3 * _sin(angleIncrement / 2) / (1 + _cos(angleIncrement / 2)), ma = cosAngle * rx, mb = sinAngle * rx, mc = sinAngle * -ry, md = cosAngle * ry, i;
	for (i = 0; i < segments; i++) {
		angle = angleStart + i * angleIncrement;
		x1 = _cos(angle);
		y1 = _sin(angle);
		ux = _cos(angle += angleIncrement);
		uy = _sin(angle);
		rawPath.push(x1 - controlLength * y1, y1 + controlLength * x1, ux + controlLength * uy, uy - controlLength * ux, ux, uy);
	}
	for (i = 0; i < rawPath.length; i += 2) {
		x1 = rawPath[i];
		y1 = rawPath[i + 1];
		rawPath[i] = x1 * ma + y1 * mc + cx;
		rawPath[i + 1] = x1 * mb + y1 * md + cy;
	}
	rawPath[i - 2] = x;
	rawPath[i - 1] = y;
	return rawPath;
}
function stringToRawPath(d) {
	var a = (d + "").replace(_scientific, function(m) {
		var n = +m;
		return n < 1e-4 && n > -1e-4 ? 0 : n;
	}).match(_svgPathExp) || [], path = [], relativeX = 0, relativeY = 0, twoThirds = 2 / 3, elements = a.length, points = 0, errorMessage = "ERROR: malformed path: " + d, i, j, x, y, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand, flag1, flag2, line = function line(sx, sy, ex, ey) {
		difX = (ex - sx) / 3;
		difY = (ey - sy) / 3;
		segment.push(sx + difX, sy + difY, ex - difX, ey - difY, ex, ey);
	};
	if (!d || !isNaN(a[0]) || isNaN(a[1])) {
		console.log(errorMessage);
		return path;
	}
	for (i = 0; i < elements; i++) {
		prevCommand = command;
		if (isNaN(a[i])) {
			command = a[i].toUpperCase();
			isRelative = command !== a[i];
		} else i--;
		x = +a[i + 1];
		y = +a[i + 2];
		if (isRelative) {
			x += relativeX;
			y += relativeY;
		}
		if (!i) {
			startX = x;
			startY = y;
		}
		if (command === "M") {
			if (segment) {
				if (segment.length < 8) path.length -= 1;
				else points += segment.length;
				_segmentIsClosed(segment);
			}
			relativeX = startX = x;
			relativeY = startY = y;
			segment = [x, y];
			path.push(segment);
			i += 2;
			command = "L";
		} else if (command === "C") {
			if (!segment) segment = [0, 0];
			if (!isRelative) relativeX = relativeY = 0;
			segment.push(x, y, relativeX + a[i + 3] * 1, relativeY + a[i + 4] * 1, relativeX += a[i + 5] * 1, relativeY += a[i + 6] * 1);
			i += 6;
		} else if (command === "S") {
			difX = relativeX;
			difY = relativeY;
			if (prevCommand === "C" || prevCommand === "S") {
				difX += relativeX - segment[segment.length - 4];
				difY += relativeY - segment[segment.length - 3];
			}
			if (!isRelative) relativeX = relativeY = 0;
			segment.push(difX, difY, x, y, relativeX += a[i + 3] * 1, relativeY += a[i + 4] * 1);
			i += 4;
		} else if (command === "Q") {
			difX = relativeX + (x - relativeX) * twoThirds;
			difY = relativeY + (y - relativeY) * twoThirds;
			if (!isRelative) relativeX = relativeY = 0;
			relativeX += a[i + 3] * 1;
			relativeY += a[i + 4] * 1;
			segment.push(difX, difY, relativeX + (x - relativeX) * twoThirds, relativeY + (y - relativeY) * twoThirds, relativeX, relativeY);
			i += 4;
		} else if (command === "T") {
			difX = relativeX - segment[segment.length - 4];
			difY = relativeY - segment[segment.length - 3];
			segment.push(relativeX + difX, relativeY + difY, x + (relativeX + difX * 1.5 - x) * twoThirds, y + (relativeY + difY * 1.5 - y) * twoThirds, relativeX = x, relativeY = y);
			i += 2;
		} else if (command === "H") {
			line(relativeX, relativeY, relativeX = x, relativeY);
			i += 1;
		} else if (command === "V") {
			line(relativeX, relativeY, relativeX, relativeY = x + (isRelative ? relativeY - relativeX : 0));
			i += 1;
		} else if (command === "L" || command === "Z") {
			if (command === "Z") {
				x = startX;
				y = startY;
				segment.closed = true;
			}
			if (command === "L" || _abs(relativeX - x) > .5 || _abs(relativeY - y) > .5) {
				line(relativeX, relativeY, x, y);
				if (command === "L") i += 2;
			}
			relativeX = x;
			relativeY = y;
		} else if (command === "A") {
			flag1 = a[i + 4];
			flag2 = a[i + 5];
			difX = a[i + 6];
			difY = a[i + 7];
			j = 7;
			if (flag1.length > 1) {
				if (flag1.length < 3) {
					difY = difX;
					difX = flag2;
					j--;
				} else {
					difY = flag2;
					difX = flag1.substr(2);
					j -= 2;
				}
				flag2 = flag1.charAt(1);
				flag1 = flag1.charAt(0);
			}
			beziers = arcToSegment(relativeX, relativeY, +a[i + 1], +a[i + 2], +a[i + 3], +flag1, +flag2, (isRelative ? relativeX : 0) + difX * 1, (isRelative ? relativeY : 0) + difY * 1);
			i += j;
			if (beziers) for (j = 0; j < beziers.length; j++) segment.push(beziers[j]);
			relativeX = segment[segment.length - 2];
			relativeY = segment[segment.length - 1];
		} else console.log(errorMessage);
	}
	i = segment.length;
	if (i < 6) {
		path.pop();
		i = 0;
	} else _segmentIsClosed(segment);
	path.totalPoints = points + i;
	return path;
}
function segmentToDistributedPoints(segment, totalPoints) {
	segment.samples || measureSegment(segment);
	var samples = segment.samples, lookup = segment.lookup, resolution = segment.resolution, totalLength = segment.totalLength, points = segment.slice(0, 2), curveStoppingPoints = [], l = segment.length - 4, i = 6, limit = .2, startLength = 0, curvePointsCumulative = 0, t, curvePoints, min, max, ci, ratioInc, j, inv, curveLength, length, a, nonSmooth, curveStoppingPointIndex, sampleIndex;
	for (; i < l; i += 6) if (Math.abs(_atan2(segment[i + 1] - segment[i - 1], segment[i] - segment[i - 2]) - _atan2(segment[i + 3] - segment[i + 1], segment[i + 2] - segment[i])) > limit) curveStoppingPoints.push(i);
	curveStoppingPoints.push(segment.length - 2);
	l = curveStoppingPoints.length;
	points.nonSmooth = nonSmooth = [1];
	if (totalPoints > l) {
		totalPoints -= l;
		for (ci = 0; ci < l; ci++) {
			curveStoppingPointIndex = curveStoppingPoints[ci];
			sampleIndex = Math.round(curveStoppingPointIndex / 6 * resolution);
			curveLength = samples[sampleIndex - 1] - startLength;
			curvePoints = Math.round(samples[sampleIndex - 1] / totalLength * totalPoints) - curvePointsCumulative;
			curvePointsCumulative += curvePoints;
			ratioInc = 1 / (curvePoints + 1);
			for (j = 1; j <= curvePoints; j++) {
				length = startLength + curveLength * j * ratioInc;
				i = lookup.length ? lookup[length < totalLength ? ~~(length / segment.minLength) : lookup.length - 1] || 0 : _getSampleIndex(samples, length, length / totalLength);
				min = i ? samples[i - 1] : 0;
				max = samples[i];
				if (max < length) {
					min = max;
					max = samples[++i];
				}
				t = 1 / resolution * ((length - min) / (max - min) + i % resolution) || 0;
				inv = 1 - t;
				i = ~~(i / resolution) * 6;
				a = segment[i];
				points.push(_round((t * t * (segment[i + 6] - a) + 3 * inv * (t * (segment[i + 4] - a) + inv * (segment[i + 2] - a))) * t + a), _round((t * t * (segment[i + 7] - (a = segment[i + 1])) + 3 * inv * (t * (segment[i + 5] - a) + inv * (segment[i + 3] - a))) * t + a));
			}
			nonSmooth[points.length] = 1;
			points.push(segment[curveStoppingPointIndex], segment[curveStoppingPointIndex + 1]);
			startLength += curveLength;
		}
	}
	i = segment.length - 2;
	if (segment.closed && Math.abs(_atan2(segment[i + 1] - segment[i - 1], segment[i] - segment[i - 2]) - _atan2(segment[3] - segment[1], segment[2] - segment[0])) <= limit) nonSmooth[0] = nonSmooth[nonSmooth.length - 1] = 0;
	return points;
}
function pointsToSegment(points, curviness) {
	_abs(points[0] - points[2]) < 1e-4 && _abs(points[1] - points[3]) < 1e-4 && (points = points.slice(2));
	var l = points.length - 2, x = +points[0], y = +points[1], nextX = +points[2], nextY = +points[3], segment = [
		x,
		y,
		x,
		y
	], dx2 = nextX - x, dy2 = nextY - y, nonSmooth = points.nonSmooth || [], closed = Math.abs(points[l] - x) < .001 && Math.abs(points[l + 1] - y) < .001, prevX, prevY, i, dx1, dy1, r1, r2, r3, tl, mx1, mx2, mxm, my1, my2, mym;
	if (!l) return [
		x,
		y,
		x,
		y,
		x,
		y,
		x,
		y
	];
	if (closed) {
		points.push(nextX, nextY);
		nextX = x;
		nextY = y;
		x = points[l - 2];
		y = points[l - 1];
		points.unshift(x, y);
		l += 4;
		nonSmooth = [0, 0].concat(nonSmooth);
	}
	curviness = curviness || curviness === 0 ? +curviness : 1;
	for (i = 2; i < l; i += 2) {
		prevX = x;
		prevY = y;
		x = nextX;
		y = nextY;
		nextX = +points[i + 2];
		nextY = +points[i + 3];
		if (x === nextX && y === nextY) continue;
		dx1 = dx2;
		dy1 = dy2;
		dx2 = nextX - x;
		dy2 = nextY - y;
		if (nonSmooth[i]) {
			segment.push(x - (x - prevX) / 4, y - (y - prevY) / 4, x, y, x + (nextX - x) / 4, y + (nextY - y) / 4);
			continue;
		}
		r1 = _sqrt(dx1 * dx1 + dy1 * dy1);
		r2 = _sqrt(dx2 * dx2 + dy2 * dy2);
		r3 = _sqrt(Math.pow(dx2 / r2 + dx1 / r1, 2) + Math.pow(dy2 / r2 + dy1 / r1, 2));
		tl = (r1 + r2) * curviness * .25 / r3;
		mx1 = x - (x - prevX) * (r1 ? tl / r1 : 0);
		mx2 = x + (nextX - x) * (r2 ? tl / r2 : 0);
		mxm = x - (mx1 + ((mx2 - mx1) * (r1 * 3 / (r1 + r2) + .5) / 4 || 0));
		my1 = y - (y - prevY) * (r1 ? tl / r1 : 0);
		my2 = y + (nextY - y) * (r2 ? tl / r2 : 0);
		mym = y - (my1 + ((my2 - my1) * (r1 * 3 / (r1 + r2) + .5) / 4 || 0));
		segment.push(_round(mx1 + mxm), _round(my1 + mym), _round(x), _round(y), _round(mx2 + mxm), _round(my2 + mym));
	}
	x !== nextX || y !== nextY || segment.length < 4 ? segment.push(_round(nextX), _round(nextY), _round(nextX), _round(nextY)) : segment.length -= 2;
	if (segment.length === 2) segment.push(x, y, x, y, x, y);
	else if (closed) {
		segment.splice(0, 6);
		segment.length -= 6;
	}
	segment.closed = closed;
	return segment;
}
function rawPathToString(rawPath) {
	if (_isNumber(rawPath[0])) rawPath = [rawPath];
	var result = "", l = rawPath.length, sl, s, i, segment;
	for (s = 0; s < l; s++) {
		segment = rawPath[s];
		result += "M" + _round(segment[0]) + "," + _round(segment[1]) + " C";
		sl = segment.length;
		for (i = 2; i < sl; i++) result += _round(segment[i++]) + "," + _round(segment[i++]) + " " + _round(segment[i++]) + "," + _round(segment[i++]) + " " + _round(segment[i++]) + "," + _round(segment[i]) + " ";
		if (segment.closed) result += "z";
	}
	return result;
}
//#endregion
export { rawPathToString as a, stringToRawPath as c, pointsToSegment as i, transformRawPath as l, convertToPath as n, reverseSegment as o, getRawPath as r, segmentToDistributedPoints as s, cacheRawPathMeasurements as t };
